import { Box, Card, Divider } from '@mui/material';
import './scss/restaurant-extensions.scss';
import i18n from '../../../i18n';
import DialogComponent from '../../../component/dialog/dialog.component';
import { CoreFileLog } from '../../../models';
import moment from 'moment';

/**
 * 核心文件日志 弹窗
 */
export default function RestaurantCoreFlieLogDialog(props: {
    open: boolean;
    onClose: () => void;
    info: CoreFileLog;
    onSave: (params: { name: string }) => void;
    dialogType: 'PREVIEW';
}) {

    const data = [
        { label: i18n.t('core_file_component_date'), value: props?.info?.date ? moment(props?.info?.date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD HH:mm:ss') : '' },
        {

            label: i18n.t('core_file_component_operator_name'),
            value: `${props?.info?.operatorFirstName || ''} ${props?.info?.operatorLastName || ''}`
        },
        {

            label: i18n.t('core_file_component_operator_type'),
            value: props?.info?.operatorType
        },
        {

            label: i18n.t('core_file_component_operating_mac_address'),
            value: props?.info?.operatorMac
        },
        {

            label: i18n.t('core_file_component_operating_ip'),
            value: props?.info?.operatorIp
        },
        {

            label: i18n.t('core_file_component_operating_id'),
            value: props?.info?.operatorId
        }

    ];

    return (
        <DialogComponent
            open={props.open}
            maxWidth={'xs'}
            sx={{ '& .MuiDialog-paper': { minWidth: '40%', } }}
            fullWidth={false}
            onClose={() => {
                props.onClose();
            }}
            defaultHeaderProps={
                {
                    title: i18n.t('core_file_component_log_details'),
                }
            }
        >
            {props.dialogType === 'PREVIEW' &&
                <Card style={{ margin: '1rem 0' }}>
                    <Box>
                        {data.map((item, index) => {
                            return (
                                <Box key={item.label + index}>
                                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} padding={'0.85rem'}>
                                        <Box component='p' sx={(theme) => { return { wordBreak: 'keep-all', marginRight: '0.5rem', color: theme.palette.text.secondary } }} >
                                            {item.label}:
                                        </Box>
                                        <Box component='p' sx={(theme) => { return { wordBreak: 'break-all', color: theme.palette.text.secondary } }} >
                                            {item.value}
                                        </Box>
                                    </Box>
                                    <Divider />
                                </Box>
                            )
                        })}
                    </Box>
                </Card>}
        </DialogComponent >
    )
}